import MyContext from "../../../../contexts/MyContext";
import { TicketForm4New } from "../ticket-forms/TicketForm4New";

export const Slide4New = (props) => {
  return <MyContext.Consumer>{(context) => <div hidden={context.activeSlide !== 3}>{<TicketForm4New {...props} />}</div>}</MyContext.Consumer>;
};
